document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantesProducto();
  initCifras();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-retraso') || 0;
          setTimeout(function () {
            entry.target.classList.add('mt-visible');
          }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-full');
        var alt = mini.getAttribute('data-alt') || '';
        if (!full) return;
        principal.src = full;
        principal.alt = alt;
        miniaturas.forEach(function (m) { m.classList.remove('mt-activa'); });
        mini.classList.add('mt-activa');
      });
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-mt-producto-form]').forEach(function (wrap) {
    var dataEl = wrap.querySelector('[data-mt-variantes]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var scope = wrap.closest('.mt-producto') || wrap.parentElement || wrap;
    var inputId = wrap.querySelector('[data-mt-id-input]');
    var precioEl = scope.querySelector('[data-mt-precio]');
    var precioCompareEl = scope.querySelector('[data-mt-precio-compare]');
    var botonComprar = wrap.querySelector('[data-mt-boton-comprar]');
    var disponibilidadEl = scope.querySelector('[data-mt-disponibilidad]') || wrap.querySelector('[data-mt-disponibilidad]');
    var textoComprar = botonComprar ? botonComprar.getAttribute('data-texto-comprar') : '';
    var textoAgotado = botonComprar ? botonComprar.getAttribute('data-texto-agotado') : '';
    var grupos = wrap.querySelectorAll('[data-mt-opcion-grupo]');
    var totalOpciones = variantes.length ? variantes[0].options.length : 0;

    function opcionesSeleccionadas() {
      var seleccion = [];
      for (var i = 0; i < totalOpciones; i++) {
        seleccion.push(variantes[0].options[i]);
      }
      grupos.forEach(function (grupo) {
        var posicion = Number(grupo.getAttribute('data-posicion'));
        var activo = grupo.querySelector('.mt-activa');
        if (activo) seleccion[posicion] = activo.getAttribute('data-valor');
      });
      return seleccion;
    }

    function encontrarVariante() {
      var sel = opcionesSeleccionadas();
      return variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === sel[i]; });
      });
    }

    function formatoMoneda(centavos) {
      return (centavos / 100).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
      if (precioCompareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioCompareEl.textContent = formatoMoneda(variante.compare_at_price);
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !variante.available;
        botonComprar.textContent = variante.available ? textoComprar : textoAgotado;
      }
      if (disponibilidadEl) {
        disponibilidadEl.textContent = variante.available ? disponibilidadEl.getAttribute('data-texto-disponible') : disponibilidadEl.getAttribute('data-texto-agotado');
      }
      if (variante.featured_image) {
        var galeria = wrap.closest('.mt-producto') ? wrap.closest('.mt-producto').querySelector('[data-mt-galeria]') : null;
        if (galeria) {
          var mini = galeria.querySelector('[data-full="' + variante.featured_image + '"]');
          if (mini) mini.click();
        }
      }
    }

    grupos.forEach(function (grupo) {
      grupo.querySelectorAll('[data-mt-opcion-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          grupo.querySelectorAll('[data-mt-opcion-valor]').forEach(function (b) { b.classList.remove('mt-activa'); });
          btn.classList.add('mt-activa');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

function initCifras() {
  var cifras = document.querySelectorAll('[data-mt-cifra]');
  if (!cifras.length) return;
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var final = parseFloat(el.getAttribute('data-mt-cifra')) || 0;
      observer.unobserve(el);
      if (reducido) {
        el.textContent = final;
        return;
      }
      var inicio = null;
      var duracion = 1400;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        el.textContent = Math.floor(progreso * final);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = final;
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  cifras.forEach(function (el) { observer.observe(el); });
}
